<template>
  <div class="pop">
    <div class="abs popCont capsuleToys">
      <p>{{ timestamp }}</p>
      <img :src="require('@images/capsuleToys.gif') + '?t=' + timestamp" alt="">
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { closePop, showPop, updateInitUser } from '@/utils/common'
import { lottery } from '@/network/api'

export default {
  data(){
    return {
      minTime: 2000,
      requested: false,
      timeEnd: false,
      timestamp: ''
    }
  },
  computed: {
    ...mapState(['currentPop']),
  },
  watch: {
    currentPop(newValue){
      if(newValue === 'CapsuleToys'){
        this.timestamp = new Date().getTime();
        this.requested = false;
        this.timeEnd = false;
        this.lotteryStart();
      }
    }
  },
  methods: {
    closePop,
    showPop,
    updateInitUser,
    lotteryStart(){
      setTimeout(() => {
        this.timeEnd = true;
        this.lotteryEnd();
      }, this.minTime)

      lottery().then(res => {
        if(res.status === 1){
          this.$.emit('lotteryDate', res.result)
          this.requested = true;
          this.lotteryEnd();
        }else if(res.status === -99){//在扭也没有啦！你已解锁全部【毒性头像】
          this.showPop('CapsuleToyNOResult');
        }else{
          alert(res.message);
        }
      })
    },
    lotteryEnd(){
      if(this.requested && this.timeEnd){
        this.updateInitUser();
        // this.closePop();
        this.showPop('CapsuleToyResult');
      }
    }
  }
}
</script>

<style scoped>
.pop{ position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.85); z-index: 10;}
.popCont{ top: 50%; left: 50%; transform: translate(-50%, -50%);}
.capsuleToys{ width: 750px; height: 1440px;}
.capsuleToys img{ width: inherit; height: inherit;}
</style>